(function () {
  function initProductZoom(root) {
    if (!root || root.dataset.tdbProductZoomReady === 'true') return;

    var image = root.querySelector('[data-tdb-product-zoom-image]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-tdb-product-zoom-thumb]'));
    var triggers = Array.prototype.slice.call(document.querySelectorAll('[data-tdb-product-zoom-open]'));
    var closeButtons = Array.prototype.slice.call(root.querySelectorAll('[data-tdb-product-zoom-close]'));
    var addButton = root.querySelector('[data-tdb-product-zoom-add]');
    var lastFocused = null;

    if (!image || !thumbs.length || !triggers.length) return;

    root.dataset.tdbProductZoomReady = 'true';

    function selectImage(index) {
      var thumb = thumbs[index] || thumbs[0];
      if (!thumb) return;

      image.src = thumb.dataset.tdbProductZoomSrc;
      image.alt = thumb.dataset.tdbProductZoomAlt || '';

      thumbs.forEach(function (item) {
        var isActive = item === thumb;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    function openZoom(index, trigger) {
      lastFocused = trigger || document.activeElement;
      selectImage(Number(index) || 0);
      root.hidden = false;
      root.setAttribute('aria-hidden', 'false');
      document.body.classList.add('tdb-product-zoom-is-open');
      var closeButton = root.querySelector('.tdb-product-zoom__close');
      if (closeButton) closeButton.focus();
    }

    function closeZoom() {
      root.hidden = true;
      root.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('tdb-product-zoom-is-open');
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        openZoom(trigger.dataset.tdbProductZoomIndex, trigger);
      });
    });

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        selectImage(Number(thumb.dataset.tdbProductZoomIndex) || 0);
      });
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', closeZoom);
    });

    if (addButton) {
      addButton.addEventListener('click', function () {
        var productSubmit = document.querySelector('.tdb-product-form button[type="submit"]');
        if (productSubmit && !productSubmit.disabled) productSubmit.click();
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !root.hidden) closeZoom();
    });
  }

  function initAllProductZooms() {
    document.querySelectorAll('[data-tdb-product-zoom]').forEach(initProductZoom);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllProductZooms);
  } else {
    initAllProductZooms();
  }

  document.addEventListener('shopify:section:load', initAllProductZooms);
})();
